import AnimatedSection from "@/components/AnimatedSection";

export default function AiCTASection() {
  return (
    <section id="contact" className="py-20 md:py-28 bg-cta-gradient relative overflow-hidden text-background-50">
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-accent-400/15 to-transparent" />
        <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-accent-400/20 to-transparent" />
        <div className="absolute top-3/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-accent-400/15 to-transparent" />
      </div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-accent-500/5 rounded-full blur-3xl" />

      <div className="container-astro relative z-10 text-center">
        <AnimatedSection>
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-500/30 bg-background-900/30 text-xs font-medium text-background-300">
            <span className="w-4 h-4 flex items-center justify-center text-accent-400">
              <i className="ri-sparkling-2-line" />
            </span>
            Ready to bring AI into your product?
          </span>
        </AnimatedSection>

        <AnimatedSection delay={120}>
          <h2 className="mt-6 text-3xl md:text-4xl lg:text-5xl font-extrabold font-heading tracking-tight text-background-50 max-w-3xl mx-auto leading-tight">
            Let's Build an AI Feature That Moves Your Business Forward
          </h2>
        </AnimatedSection>

        <AnimatedSection delay={240}>
          <p className="mt-5 text-base md:text-lg text-background-400 max-w-2xl mx-auto leading-relaxed">
            Tell us about your idea and we'll help you design, build and ship an AI solution that's reliable, secure and cost-efficient.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={360}>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316] text-white text-base font-semibold rounded-xl hover:brightness-110 hover:-translate-y-0.5 transition-all duration-300 shadow-lg shadow-[#7C3AED]/30 whitespace-nowrap btn-arrow-hover group"
            >
              Start Your AI Project
              <i className="ri-arrow-right-line btn-arrow transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-8 py-4 border border-background-400/40 text-background-100 text-base font-semibold rounded-xl hover:bg-background-50/10 hover:-translate-y-0.5 transition-all duration-300 whitespace-nowrap btn-arrow-hover group"
            >
              Talk to an AI Expert
              <i className="ri-chat-1-line btn-arrow transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}